<template>
  <div
    class="search-bar"
    :class="{'search-bar__mobile-icon': mobileIcon}"
  >
    <a
      v-show="isMobile && mobileIcon"
      type="button"
      class="search-bar__button"
      :aria-label="$string('search.search')"
      @click="toggleOverlay({
        component: 'predictive-search-bar',
        ignoreDismissed: true,
        namespace: 'predictiveSearch',
      })"
    >
      <span
        v-show="getActiveOverlay != 'predictiveSearch'"
        class="search-bar__icon"
      >
        <icon-search />
      </span>
      <span
        v-show="getActiveOverlay === 'predictiveSearch'"
        class="search-bar__close"
      >
        <icon-close />
      </span>
    </a>
    <div
      v-show="showInput"
      class="search-bar__wrapper"
    >
      <span
        class="search-bar__icon"
      >
        <icon-search />
      </span>
      <input
        ref="search"
        class="search-bar__input"
        type="search"
        :placeholder="$string('search.search')"
        autocomplete="off"
        :tabindex="0"
        @click="openOverlay({
          component: 'predictive-search-bar',
          ignoreDismissed: true,
          namespace: 'predictiveSearch',
        })"
        @keyup.enter="submitSearch"
        v-model="query"
      >
    </div>
  </div>
</template>

<script>

/**
 * Vue: Search bar (search-bar)
 * -----------------------------------------------------------------------------
 * Search bar input that opens predictive search modal, but updates query to
 * match modal, and can be submitted.
 * @param {Boolean} mobileIcon - Whether to display as an icon only on mobile.
 *
 */

import IconClose from '~icons/misc/close.svg'
import IconSearch from '~icons/misc/search.svg'

import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'SearchBar',

  components: {
    IconClose,
    IconSearch,
  },

  props: {
    mobileIcon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      query: '',
    }
  },

  computed: {

    /**
     * Map Vuex getters.
     */
    ...mapGetters({
      getActiveOverlay: 'overlays/getActiveOverlay',
    }),

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    /**
     * Compute if input should display.
     * @returns {Boolean}
     */
    showInput() {
      if (!this.mobileIcon || !this.isMobile) {
        return true
      }

      return false
    },

  },

  mounted() {
    this.setEventBusListeners()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
      openOverlay: 'overlays/open',
    }),

    /**
     * Redirect to search results page when enter is pressed
     * on desktop search bar (not modal).
     */
    submitSearch() {
      window.location.href = `/search?q=${this.$refs.search.value}`
    },

    /**
     * Update site header search input to match search modal input value.
     * @param {String} query
     */
    updateQuery(query) {
      this.query = query
    },

    /**
     * Set EventBus listeners.
     */
    setEventBusListeners() {

      /**
       * Overlay listeners act as fallbacks for non-Vue components.
       */
      cnvs.EventBus.listen('update-query', (query) => {
        this.query = query
      })
    },
  },
}
</script>

<style lang="scss">
@import './search-bar';
</style>
